import { render, staticRenderFns } from "./ParametersPage.vue?vue&type=template&id=88e7ca16&scoped=true"
import script from "./ParametersPage.vue?vue&type=script&lang=js"
export * from "./ParametersPage.vue?vue&type=script&lang=js"
import style0 from "./ParametersPage.vue?vue&type=style&index=0&id=88e7ca16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e7ca16",
  null
  
)

export default component.exports